import styled, { keyframes }  from 'styled-components';
import SvgsEmptys from "@/components/svgs/empty";

const PageEmptyWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    display: flex;
    width:100%;

    &.height100 {
        min-height: 0;
        height: 100%;
    }

    .info {
        text-align: center;

        & > div {
            margin-top: 15px;
            font-size: 14px;
            color: #bec0c4;
            text-align: center;
            
            a {
                color: #55CADB;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
    
`

const Empty = ({ height100, type, text }) => {
    return (
        <PageEmptyWrapper className={height100 ? 'height100' : ''}>
            <div className='info'>
                <SvgsEmptys type="nodata" />
                <div>{text || 'Here is empty'}</div>
            </div>
        </PageEmptyWrapper>
    )
}

export default Empty